import { LitElement, css, html } from 'lit';
import { customElement, state } from 'lit/decorators';

import { ChallengeReward } from '../types';

@customElement('challenge-award-announcement')
export class ChallengeAwardAnnouncement extends LitElement {

    @state()
    challengeReward: ChallengeReward[] = [];

    render() {
        return html`
            <div class="modalContent">
                <div class="modal__content">
                    <div class="awards__container">
                        ${this.challengeReward.map((reward) => html`
                            <div class="awards__card">
                                <img
                                    src="${reward.image_url}"
                                    class="award-icon"
                                    alt="${reward.title}"
                                />
                                <div class="awards__label">${reward.title}</div>
                                <p class="title">${reward.description}</p>

                                ${reward.completion_message ? html`
                                    <p>${reward.completion_message}</p>
                                ` : ''}

                                ${reward.completion_url ? html`
                                    <a
                                        href="${reward.completion_url}"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        class="reward-link"
                                    >
                                        <translated-span>View Reward</translated-span>
                                        <mwc-icon>open_in_new</mwc-icon>
                                    </a>
                                ` : ''}

                                ${(reward.bonus_points ?? 0) > 0 ? html`
                                    <p class="bonus-points-text">+${reward.bonus_points} <translated-span>bonus points!</translated-span></p>
                                ` : ''}
                            </div>
                        `)}
                    </div>
                </div>
            </div>
        `;
    }

    static get styles() {
        return css`
            :host {
                --modal-width: 550px;
            }

            .modalContent {
                position: relative;
                max-height: calc(80vh - 180px);
                height: auto;
                overflow-y: auto;
                box-sizing: border-box;
            }

            .modal__header {
                width: 100%;
                text-align: center;
                padding: 15px 20px;
                border-bottom: solid 1px #efecf3;
                color: var(--theme-input-color);
                font-size: 18px;
                font-weight: 700;
                line-height: 1.3em;
                box-sizing: border-box;
            }

            .modal__content {
                padding: 20px 0;
                width: 100%;
                box-sizing: border-box;
            }

            p.title {
                color: #000000;
                text-align: center;
                font-size: 16px;
                font-weight: 700;
                line-height: 150%;
                margin: 0;
            }

            .awards__container {
                width: 100%;
                display: flex;
                align-items: flex-start;
                justify-content: center;
                overflow-x: auto;
                gap: 2px;
                padding-bottom: 10px;
                box-sizing: border-box;
            }

            .awards__card {
                display: flex;
                padding: 0px 5px;
                flex-direction: column;
                align-items: center;
                gap: 5px;
                flex: 1;
            }

            .award-icon {
                width: 62px;
                height: 62px;
            }

            .awards__label {
                color: #000000;
                text-align: center;
                line-height: 125%;
            }

            .reward-link {
                color: var(--main-primary-color);
                text-decoration: none;
                font-weight: 600;
                font-size: 14px;
                margin-top: 8px;
                display: inline-block;
                padding: 8px 16px;
                border-radius: 4px;
                border: 1px solid var(--main-primary-color);
                transition: all 0.2s ease;
                display: flex;
                gap: 1rem;
            }

            .reward-link:hover {
                background-color: var(--main-primary-color);
                color: var(--theme-white-color);
            }

            .bonus-points-text {
                color: #4caf50;
                font-weight: 700;
                font-size: 14px;
                margin: 8px 0 0 0;
            }

            @media only screen and (max-width: 550px) {
                .modalContent {
                    width: 100%;
                    min-height: 100%;
                    max-height: 100%;
                }
            }
        `;
    }
}
